import { AsyncStoreItem } from '@lib';
import { PostJourneysGetJourneyResponse } from 'src/sdk_checkin';

/**
 * CprResult model
 */
export interface CprResultModel {
  model: PostJourneysGetJourneyResponse | null;
}

/**
 * PostJourneysGetJourneyResponse model details
 */
export interface CprResultStateDetails extends AsyncStoreItem {}

/**
 * CprResult store state
 */
export interface CprResultState extends CprResultStateDetails, CprResultModel {}

/**
 * Name of the CprResult Store
 */
export const CPR_RESULT_STORE_NAME = 'cprResult';

/**
 * CprResult Store Interface
 */
export interface CprResultStore {
  /** CprResult state */
  [CPR_RESULT_STORE_NAME]: CprResultState;
}
